import { getLocalData } from 'services/utils';
import { actions } from 'store/actions';

export const setLocalDataToStore = () => dispatch => {
  dispatch(actions.setLocalDataToStore.act(getLocalData()));
};
